var map = {
	"./aff.png": "./openbrix-design-system/images/banner/mobile/aff.png",
	"./cb.png": "./openbrix-design-system/images/banner/mobile/cb.png",
	"./credit_back.png": "./openbrix-design-system/images/banner/mobile/credit_back.png",
	"./dashboard.png": "./openbrix-design-system/images/banner/mobile/dashboard.png",
	"./document.png": "./openbrix-design-system/images/banner/mobile/document.png",
	"./happy.png": "./openbrix-design-system/images/banner/mobile/happy.png",
	"./id.png": "./openbrix-design-system/images/banner/mobile/id.png",
	"./market.png": "./openbrix-design-system/images/banner/mobile/market.png",
	"./my-account.png": "./openbrix-design-system/images/banner/mobile/my-account.png",
	"./openflow.png": "./openbrix-design-system/images/banner/mobile/openflow.png",
	"./ref.png": "./openbrix-design-system/images/banner/mobile/ref.png",
	"./rewards.png": "./openbrix-design-system/images/banner/mobile/rewards.png",
	"./rtr.png": "./openbrix-design-system/images/banner/mobile/rtr.png",
	"./ti.png": "./openbrix-design-system/images/banner/mobile/ti.png",
	"./tp.png": "./openbrix-design-system/images/banner/mobile/tp.png",
	"./trustpilot.png": "./openbrix-design-system/images/banner/mobile/trustpilot.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./openbrix-design-system/images/banner/mobile sync recursive ^\\.\\/.*$";